var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_422_1124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_422_1124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21.0001C4.45 21.0001 3.97917 20.8043 3.5875 20.4126C3.19583 20.0209 3 19.5501 3 19.0001V5.0001C3 4.4501 3.19583 3.97926 3.5875 3.5876C3.97917 3.19593 4.45 3.0001 5 3.0001H13.925L11.925 5.0001H5V19.0001H19V12.0501L21 10.0501V19.0001C21 19.5501 20.8042 20.0209 20.4125 20.4126C20.0208 20.8043 19.55 21.0001 19 21.0001H5ZM9 15.0001V10.7501L18.175 1.5751C18.375 1.3751 18.6 1.2251 18.85 1.1251C19.1 1.0251 19.35 0.975098 19.6 0.975098C19.8667 0.975098 20.1208 1.0251 20.3625 1.1251C20.6042 1.2251 20.825 1.3751 21.025 1.5751L22.425 3.0001C22.6083 3.2001 22.75 3.42093 22.85 3.6626C22.95 3.90426 23 4.1501 23 4.4001C23 4.6501 22.9542 4.89593 22.8625 5.1376C22.7708 5.37926 22.625 5.6001 22.425 5.8001L13.25 15.0001H9ZM11 13.0001H12.4L18.2 7.2001L17.5 6.5001L16.775 5.8001L11 11.5751V13.0001Z",
    fill: "#F25C05"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.15acdedca9c5b5d2d5748895d167ece6.svg";
export { ForwardRef as ReactComponent };